var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ED1650"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.48 10h-4.044a.616.616 0 00-.44.186l-7.375 7.529a.616.616 0 01-.44.186H9.829a.616.616 0 01-.44-.186l-.956-.974a.639.639 0 01-.183-.447v-1.377a.64.64 0 01.183-.448l.956-.974a.617.617 0 01.44-.186h1.352c.165 0 .323.067.44.186l.587.598a.614.614 0 00.88 0l1.419-1.444a.642.642 0 000-.896l-1.54-1.567a.617.617 0 00-.44-.186H8.483a.617.617 0 00-.44.186l-2.86 2.912a.64.64 0 00-.182.448v4.118c0 .168.066.33.182.448l2.86 2.913a.617.617 0 00.44.185h4.045a.617.617 0 00.44-.186l7.375-7.528a.617.617 0 01.44-.187h1.352c.165 0 .323.067.44.186l.956.974a.64.64 0 01.183.448v1.377a.64.64 0 01-.183.447l-.956.974a.616.616 0 01-.44.186h-1.352a.616.616 0 01-.44-.186l-.592-.603a.614.614 0 00-.875-.005l-1.75 1.742a.64.64 0 00-.187.453v4.04c0 .35.279.634.622.634h2.04a.628.628 0 00.623-.633v-1.5c0-.35.279-.633.622-.633h2.635a.617.617 0 00.44-.185l2.86-2.913a.64.64 0 00.183-.448v-4.118a.64.64 0 00-.182-.448l-2.86-2.912a.617.617 0 00-.44-.186"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcp);
export default __webpack_public_path__ + "static/media/xcp.195c28465203c1ec815c971429089d91.svg";
export { ForwardRef as ReactComponent };